import { useState } from "react";
import VideoSection from "./sections/video";
import HeroSection from "./sections/hero";
import InnovationSection from "./sections/innovation";
import DesignSection from "./sections/design";
import ModelsSection from "./sections/models";
import ShowcaseSection from "./sections/showcase";
import FeaturesSection from "./sections/features";
import ColorPanelSection from "./sections/models/ColorPanel";
import Logo from "./logo.png";
import Mcm from "../src/img/mcm.png";
import icArrowUp from "./arrow-up.svg";

import "./App.css";
import "react-aspect-ratio/aspect-ratio.css";

function App() {
  const [active, setActive] = useState(0);
  return (
    <div className="root">
      <main>
        <VideoSection />
        <HeroSection />
        <InnovationSection />
        <DesignSection />
        <ModelsSection active={active} />
        <ShowcaseSection />
        <FeaturesSection active={active} setActive={setActive} />
        <ColorPanelSection active={active} setActive={setActive} />
      </main>
      <footer className="footer relative">
        <div className="container mx-auto">
          <div className="info flex flex-row">
            <div className="flex flex-1 flex-col items-start md:flex-row md:items-center">
              <img
                src={Logo}
                className="footer-logo pb-8 md:pb-0 md:pl-4 md:pr-4 md:mr-24"
                alt="logo"
              />
              <div className="md:pr-28">
                <div>
                  บริษัท มิตซูบิชิ อีเล็คทริค กันยงวัฒนา จำกัด (สำนักงานใหญ่
                  กรุงเทพกรีฑา)
                  <br />
                  <span className="whitespace">เลขที่ 28 ถนนกรุงเทพกรีฑา </span>
                  <span className="whitespace-nowrap">แขวงหัวหมาก </span>
                  <span className="md:whitespace-nowrap">เขตบางกะปิ </span>
                  <span className="whitespace-nowrap">กทม. 10240</span>
                </div>
                <div>
                  <span className="md:whitespace-nowrap">
                    โทรศัพท์ : 0-2763-7000{" "}
                  </span>
                  <span className="md:whitespace-nowrap">
                    โทรสาร : 0-2379-4759-62{" "}
                  </span>
                </div>
              </div>
            </div>
            <button
              className="hidden md:flex flex-col justify-between items-center px-3"
              onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            >
              <img className="up-icon" src={icArrowUp} alt="up" />
              TOP
            </button>
          </div>
          <div className="flex flex-col items-start gap-3 xl:flex-row xl:justify-between">
            <div></div>
            <div className="footer--text md:text-center">
              COPYRIGHT © 2024 MITSUBISHI ELECTRIC KANG YONG WATANA CO., LTD.
              ALL RIGHTS RESERVED
            </div>
            <img
              src={Mcm}
              alt="mandatory certificate mark"
              className="w-auto h-14"
            />
          </div>
        </div>
        <button
          className="absolute md:hidden bottom-8 right-8 md:bottom-24"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        >
          <img className="up-icon" src={icArrowUp} alt="up" />
          TOP
        </button>
      </footer>
    </div>
  );
}

export default App;
